/**
 * 评测配置两页共用（批 3 B 路）：选题库快照（默认最新）、字段行、三态外壳。
 */
import type { ReactNode } from "react";

import { Card, CardContent } from "@/components/ui/card";
import { LoadingInline } from "@/components/ui/feedback";
import { LabeledSelect } from "@/components/ui/select";
import { planErrorMessage } from "@/lib/api/plan-lab";

import { FailState } from "../kit/fail-state";

export function shortTime(s?: string | null): string {
	if (!s) return "—";
	const d = new Date(s);
	if (Number.isNaN(d.getTime())) return s;
	const p = (n: number) => String(n).padStart(2, "0");
	return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

/** 选题库快照：下拉列出全部快照，第一项（最新）标「最新」 */
export function BankPicker({
	rows,
	value,
	onChange,
}: {
	rows: { bank_id: string; exported_at?: string | null }[];
	value: string;
	onChange: (v: string) => void;
}) {
	return (
		<LabeledSelect
			label="题库快照"
			value={value}
			onChange={onChange}
			options={rows.map((r, i) => ({
				value: r.bank_id,
				label: `${r.bank_id}${i === 0 ? "（最新）" : ""} · ${shortTime(r.exported_at)}`,
			}))}
		/>
	);
}

export function Field({ label, children }: { label: string; children: ReactNode }) {
	return (
		<div className="min-w-0 space-y-1">
			<div className="text-xs text-text-muted">{label}</div>
			<div className="whitespace-pre-wrap break-words text-sm text-text-primary">{children}</div>
		</div>
	);
}

/** 一级块的加载 ／ 失败外壳（三态都打同一个一级块标记，布局量测靠它找块） */
export function BlockState({
	testId,
	q,
	failTestId,
}: {
	testId: string;
	q: { isLoading: boolean; error: unknown; refetch: () => unknown; isFetching: boolean };
	failTestId: string;
}) {
	return (
		<Card data-testid={testId}>
			<CardContent className={q.isLoading ? "py-4" : undefined}>
				{q.isLoading ? (
					<LoadingInline />
				) : (
					<FailState
						reason={planErrorMessage(q.error)}
						onRetry={() => q.refetch()}
						retrying={q.isFetching}
						testId={failTestId}
					/>
				)}
			</CardContent>
		</Card>
	);
}

export const SEALED_TEXT = "盲测题，题面不公开";
